import { updateModalsKey } from 'hooks/queries/updateModals/updateModalsKeys'
import { UpdateModal } from 'hooks/queries/updateModals/useUpdateModals'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useEffect } from 'react'
import { useQueryClient } from 'react-query'

export const useUpdateModalsWebsocket = () => {
  const queryClient = useQueryClient()
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!websocketConnection) return
    const handleWebsocketMessage = (updateModal: UpdateModal) => {
      queryClient.setQueryData(updateModalsKey, (old: UpdateModal[] = []) => {
        const updatedModals = [updateModal, ...old.filter((modal) => modal.id !== updateModal.id)]
        return updatedModals
      })
    }

    const subscription = websocketConnection.subscriptions.create(
      { channel: 'UpdateModalsChannel' },
      { received: handleWebsocketMessage },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [websocketConnection, queryClient])
}
